module.exports = __webpack_public_path__ + "static/media/vi.ebaa3b94.png";